import { ReactNode } from 'react'

import { HiOutlineInformationCircle } from 'react-icons/hi'

import { Box, BoxProps, HStack, Icon, Text, Tooltip } from '@chakra-ui/react'

interface RuleSectionIProps extends BoxProps {
  children: ReactNode
  label?: string
  tooltipText?: string
}

export const RuleSection = ({
  children,
  label,
  tooltipText,
  ...rest
}: RuleSectionIProps) => {
  return (
    <Box
      bg='white'
      borderColor='rgba(9, 30, 66, 0.14)'
      borderRadius='8px'
      borderWidth='2px'
      padding='20px'
      {...rest}
    >
      {label && (
        <HStack alignItems='flex-start' justifyContent='space-between'>
          <Text fontSize='16px' fontWeight='semibold' mb={4}>
            {label}
          </Text>
          {tooltipText && (
            <Tooltip label={tooltipText} placement='right' shouldWrapChildren>
              <Icon as={HiOutlineInformationCircle} color='#33344B' />
            </Tooltip>
          )}
        </HStack>
      )}
      {children}
    </Box>
  )
}
